import { motion } from "framer-motion";
import { PROCESS } from "@/lib/siteData";

export default function Process() {
    return (
        <section id="process" data-testid="process" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <div className="max-w-2xl mb-14">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="divider-gold" />
                        <span className="uppercase tracking-[0.28em] text-xs text-gold font-medium">
                            Our Process
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight">
                        From first conversation to final key.
                    </h2>
                </div>

                <div className="relative">
                    {/* vertical line */}
                    <div className="absolute left-4 md:left-1/2 top-2 bottom-2 w-px bg-border" />

                    <div className="space-y-10 md:space-y-14">
                        {PROCESS.map((p, i) => {
                            const isRight = i % 2 === 1;
                            return (
                                <motion.div
                                    key={p.title}
                                    data-testid={`process-step-${i}`}
                                    initial={{ opacity: 0, y: 24 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-80px" }}
                                    transition={{ duration: 0.5, delay: 0.05 * i }}
                                    className={`relative grid grid-cols-[40px_1fr] md:grid-cols-2 gap-4 md:gap-14 items-start`}
                                >
                                    {/* Dot */}
                                    <div className={`md:hidden`}>
                                        <div className="relative">
                                            <div className="h-4 w-4 rounded-full bg-gold gold-pulse mt-2 ml-2" />
                                        </div>
                                    </div>

                                    {/* Left column (desktop) */}
                                    <div
                                        className={`hidden md:block ${
                                            isRight ? "order-1" : "order-1 text-right pr-16"
                                        }`}
                                    >
                                        {!isRight && (
                                            <StepContent step={p} index={i} align="right" />
                                        )}
                                    </div>

                                    {/* Center dot desktop */}
                                    <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-2">
                                        <div className="h-4 w-4 rounded-full bg-gold gold-pulse ring-4 ring-background" />
                                    </div>

                                    {/* Right column desktop */}
                                    <div
                                        className={`hidden md:block ${
                                            isRight ? "order-2 pl-16" : "order-2"
                                        }`}
                                    >
                                        {isRight && (
                                            <StepContent step={p} index={i} align="left" />
                                        )}
                                    </div>

                                    {/* Mobile content */}
                                    <div className="md:hidden">
                                        <StepContent step={p} index={i} align="left" />
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

function StepContent({ step, index, align }) {
    return (
        <div className={`${align === "right" ? "md:text-right" : ""}`}>
            <div className="text-xs font-mono text-gold tracking-widest mb-2">
                STEP · {String(index + 1).padStart(2, "0")}
            </div>
            <h3 className="font-display text-2xl md:text-3xl tracking-tight">
                {step.title}
            </h3>
            <p className="mt-2 text-muted-foreground text-sm md:text-base max-w-md md:inline-block">
                {step.desc}
            </p>
        </div>
    );
}
